import React from 'react';
import { connect } from 'react-redux';
import RegisterMe from '../Components/RegisterMe'
import { getFields, saveMember, getHtmlSnippet, briqPayLogin } from '../Actions/RegisterMe.action'

const RegisterMeContainer = props => (
    <RegisterMe {...props} />
)

const mapStateToProps = state => {
    return {
        fields: state.registerMe.fields,
        status: state.registerMe.status,
        htmlSnippet: state.registerMe.htmlSnippet,
        briqpayLoginSuccess: state.registerMe.briqpayLoginSuccess
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getFields: (type, token) => dispatch(getFields(type, token)),
        saveMember: (data) => dispatch(saveMember(data)),
        getHtmlSnippet: () => dispatch(getHtmlSnippet()),
        briqPayLogin: () => dispatch(briqPayLogin()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterMeContainer);
